import { Node, mergeAttributes } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import React, { useMemo } from 'react';
import { Code2 } from 'lucide-react';

const HtmlEmbedView = ({ node }) => {
  const htmlContent = useMemo(() => {
    try {
      return atob(node.attrs.content);
    } catch {
      return '';
    }
  }, [node.attrs.content]);

  return (
    <NodeViewWrapper className="html-embed-wrapper my-6" data-testid="html-embed-node">
      <div className="flex items-center gap-2 px-3 py-1.5 bg-muted/50 border border-border border-b-0 rounded-t-lg text-xs text-muted-foreground">
        <Code2 className="w-3.5 h-3.5" />
        <span>Interactive HTML</span>
      </div>
      <iframe
        srcDoc={htmlContent}
        sandbox="allow-scripts"
        className="w-full border border-border rounded-b-lg bg-white"
        style={{ minHeight: '400px', resize: 'vertical', overflow: 'auto' }}
        title="Embedded HTML content"
      />
    </NodeViewWrapper>
  );
};

export const HtmlEmbed = Node.create({
  name: 'htmlEmbed',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      content: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-html-embed]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-html-embed': '' }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(HtmlEmbedView);
  },
});

export default HtmlEmbed;
